import { Button, Form, Input } from "antd";

const { TextArea } = Input;

export function AddEditPostTypeForm({ loading, form, onSubmit }) {
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} autoComplete="off">
      <Form.Item
        label="Tên loại tin tức"
        name="name"
        rules={[
          { required: true, message: "Vui lòng nhập tên loại tin tức!" },
          { min: 2, max: 100, message: "Tên phải từ 2 đến 100 ký tự!" },
        ]}
      >
        <Input placeholder="Nhập tên loại tin tức" />
      </Form.Item>

      <Form.Item
        label="Mô tả"
        name="description"
        rules={[{ max: 500, message: "Mô tả không quá 500 ký tự!" }]}
      >
        <TextArea placeholder="Nhập mô tả" rows={4} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>
          Lưu
        </Button>
      </Form.Item>
    </Form>
  );
}
